<template>
  <rental-worksite
    v-if="typeMission === 'reservation'"
    type-vue="create"
    :type-mission="typeMission"
  />
  <rental-delivery
    v-else-if="typeMission === 'livraison'"
    type-vue="create"
    :type-mission="typeMission"
  />
  <rental-transfer
    v-else-if="typeMission === 'transfert'"
    type-vue="create"
    :type-mission="typeMission"
  />
</template>

<script>
import RentalWorksite from '@/components/driver/rentalCoupon/RentalWorksite';
import RentalDelivery from '@/components/driver/rentalCoupon/RentalDelivery';
import RentalTransfer from '@/components/driver/rentalCoupon/RentalTransfer';

export default {
  name: 'OutsourcingRentalCouponReservationCreate',
  components: {
    RentalWorksite,
    RentalDelivery,
    RentalTransfer,
  },
  computed: {
    typeMission() {
      if (!this.$route) return null;

      switch (this.$route.params.prefix) {
        case 'r':
          return 'reservation';
        case 'l':
          return 'livraison';
        case 't':
          return 'transfert';
        default:
          return null;
      }
    },
  },
};
</script>
